import { create } from 'zustand';

interface SuggestionTabAlertsState {
  unseenCount: number;
}

interface SuggestionTabAlertsActions {
  setUnseenCount: (count: number) => void;
  reset: () => void;
}

const INITIAL_STATE: SuggestionTabAlertsState = { unseenCount: 0 };

export const useSuggestionTabAlertsStore = create<
  SuggestionTabAlertsState & SuggestionTabAlertsActions
>((set) => ({
  ...INITIAL_STATE,
  setUnseenCount: (unseenCount) => set({ unseenCount }),
  reset: () => set(INITIAL_STATE),
}));
